// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.property.LeasingPropertyOuidWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid,
  LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetPropertyInfoFromOuidResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetPropertyInfoFromOuidParams {
  ouid: string;
}

export type LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Options = UseQueryOptions<
  GetPropertyInfoFromOuidResponseDto,
  unknown,
  GetPropertyInfoFromOuidResponseDto,
  readonly [string, GetPropertyInfoFromOuidParams]
>;

const LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_GetKey = (getParams: GetPropertyInfoFromOuidParams) =>
  [LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Path, getParams] as const;

export const LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_queryOptions = (
  getParams: GetPropertyInfoFromOuidParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_GetKey(getParams),
    queryFn: () => LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get property data for listing from ouid
 */
export const useLeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid = (
  getParams: GetPropertyInfoFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid.getKey =
  LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_GetKey;
